import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import {
  BulkFeatureItem, CreateModule, Module, ModuleAssignItem, ModuleAssignmentStatus,
  ModuleWithPermissions, UpdateModule
} from '../models/module.model';
import { Feature } from '../models/permission.model';
import { PagedResult } from '../models/external-sync.model';

@Injectable({ providedIn: 'root' })
export class ModuleService {
  private http = inject(HttpClient);
  private url = `${environment.rpsApiUrl}/api/modules`;

  getAll() { return this.http.get<Module[]>(this.url); }
  getPaged(page: number, pageSize: number, search?: string) {
    let params = new HttpParams().set('page', page).set('pageSize', pageSize);
    if (search) params = params.set('search', search);
    return this.http.get<PagedResult<Module>>(`${this.url}/paged`, { params });
  }
  getById(id: string) { return this.http.get<ModuleWithPermissions>(`${this.url}/${id}`); }
  create(dto: CreateModule) { return this.http.post<Module>(this.url, dto); }
  update(id: string, dto: UpdateModule) { return this.http.put<Module>(`${this.url}/${id}`, dto); }
  delete(id: string) { return this.http.delete(`${this.url}/${id}`); }

  bulkCreateFeatures(moduleId: string, features: BulkFeatureItem[]) {
    return this.http.post<Feature[]>(`${this.url}/${moduleId}/features/bulk`, { features });
  }

  assignToRole(moduleId: string, roleId: string, isAllowed: boolean) {
    return this.http.post(`${this.url}/${moduleId}/assign-role`, { roleId, isAllowed });
  }

  assignToUser(moduleId: string, userId: string, isAllowed: boolean) {
    return this.http.post(`${this.url}/${moduleId}/assign-user`, { userId, isAllowed });
  }

  getRoleAssignmentStatus(roleId: string) {
    return this.http.get<ModuleAssignmentStatus[]>(`${this.url}/assignment-status/role/${roleId}`);
  }

  getUserAssignmentStatus(userId: string) {
    return this.http.get<ModuleAssignmentStatus[]>(`${this.url}/assignment-status/user/${userId}`);
  }

  assignModulesToRole(roleId: string, modules: ModuleAssignItem[]) {
    return this.http.post(`${this.url}/assign-role/bulk`, { roleId, modules });
  }

  assignModulesToUser(userId: string, modules: ModuleAssignItem[]) {
    return this.http.post(`${this.url}/assign-user/bulk`, { userId, modules });
  }
}
